import ContentFascia4Item from './ContentFascia4Item';

export default ContentFascia4Item;
